import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { BackednResponse } from "@shared/lib/types";
import { useCallback } from "react";
import { AI_WORKSPACE_QUERY_KEYS } from "../constants";
import { AiWorkspaceService } from "../services/aiWorkspace.service";
import {
  IConceptualiseCreatorScriptPayload,
  ICreatorScriptGeneratorJobDetail,
} from "../types";
import { readApiError } from "./readApiError";

export function useConceptualiseCreatorScript() {
  const conceptualiseCreatorScript = useCallback(
    (payload: IConceptualiseCreatorScriptPayload) =>
      AiWorkspaceService.conceptualiseCreatorScript(payload).catch(async (err) => {
        ToastService.error(await readApiError(err, "Failed to generate concepts"));
        throw err;
      }),
    []
  );

  const { mutate: conceptualise, isLoading } = useMutation<
    IConceptualiseCreatorScriptPayload,
    BackednResponse<ICreatorScriptGeneratorJobDetail>
  >({
    mutationFn: conceptualiseCreatorScript,
    options: { skipInvalidation: true },
    onSuccess: (client) => {
      client.invalidateQueries({ queryKey: [AI_WORKSPACE_QUERY_KEYS.CREATOR_SCRIPT_JOB] });
    },
  });

  return { conceptualise, isConceptualising: isLoading };
}
